import highlights from "../images/projects/HighLights.jpg"
import neofruits from "../images/projects/NeoFruits.jpg"

export default [
  {
    title: "High Lights",
    description: "Portafolio fotografico para la empresa HighLights",
    url: "https://bodashl.com/",
    image: highlights,
  },
  {
    title: "Neo Fruits",
    description: "Pagina Web para la empresa Neo Fruits de frutas leofilizadas",
    url: "http://neofruits.com.mx/",
    image: neofruits,
  },
]
